import { ComponentSignature } from '../utils/component-signature';
import type { PublicComponent, PublicDividerElement } from '../contracts';

const Divider: PublicComponent<HTMLBRElement, PublicDividerElement> = () => null;

Divider.signature = ComponentSignature.DIVIDER;

export default Divider;
